






const actions = {
  setDevice({ commit }, devId) {
    commit('SET_DEVICE', devId)
  },

  setDevList({ commit }, list) {
    commit('SET_LIST', list)
  },
  setDevType({ commit }, devType) {
    commit('SET_DEVTYPE', devType)
  },
  setHomeId({ commit }, devId) {
    commit('SET_HOMEID', devId)
  },
  setCellId({ commit }, devId) {
    commit('SET_CELLID', devId)
  },
}





const state = {

  devId: "",
  devList:[],
  devType: "",
}

const mutations = {

  SET_DEVICE: (state, list) => {
    state.devId=list;
  },
  SET_LIST: (state, list) => {
    state.devList=list;
  },
  SET_DEVTYPE: (state, list) => {
    state.devType=list;
  },
  SET_HOMEID: (state, list) => {
    state.devHomeId = list;
  },
  SET_CELLID: (state, list) => {
    state.devCellId = list;
  },
}



export default {
  namespaced: true,
  state,
  mutations,
  actions
}
